<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 通知情報の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>通知情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/notice.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 既読にするボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した通知を既読状態にします。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 未読に戻すボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した通知を未読状態に戻します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter・通知種別・未読のみ
        </div>
        <div class="manual-explain">
          通知一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: タイトル、通知種別（プルダウンによるフィルタリング）、未読のみにチェックを入れることで未読の通知のみ表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 通知一覧
        </div>
        <div class="manual-explain">
          通知情報の一覧が表示されます。<br>
          詳細アイコンをクリックすることで通知の詳細が表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Notification Information
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Notification Information</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_notice.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Mark as Read Button
        </div>
        <div class="manual-explain">
          Clicking this button will mark the selected notification as read.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Mark as Unread Button
        </div>
        <div class="manual-explain">
          Clicking this button will return the selected notification to unread status.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter · Notification Type · Unread Only
        </div>
        <div class="manual-explain">
          Filters the data displayed in the notification list.<br>
          * Filtering criteria: Title, notification type (filtered via dropdown), or check "Unread Only" to display only unread notifications.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Notification List
        </div>
        <div class="manual-explain">
          Displays a list of notifications.<br>
          Clicking the details icon will display the detailed information of the notification.<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>
</div>
